import {
  get_serializableAnnotations9pir9fao2oo as get_serializableAnnotations,
  StringValue3u4w9lwhg0ah4 as StringValue,
  ByteValue2mrn88qw6dczw as ByteValue,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { titleCasej01kvzva6qlf as titleCase } from '../../casing.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  first28gmhyvs4kf06 as first,
  minOrNull1g8m0136x75mg as minOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FieldVisibility_EDIT_getInstance3hsitptq9f6o8 as FieldVisibility_EDIT_getInstance } from './ByFieldRenderer.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_displayName(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = get_serializableAnnotations(_this__u8e3s4);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.DisplayName') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p3('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x4v_1;
  return tmp4_elvis_lhs == null ? titleCase(substringAfterLast(substringBefore(_this__u8e3s4.az().h10(), _Char___init__impl__6a9atx(60)), _Char___init__impl__6a9atx(46))) : tmp4_elvis_lhs;
}
function get_descriptionOrDisplayName(_this__u8e3s4) {
  var tmp0_elvis_lhs = get_description(_this__u8e3s4);
  return tmp0_elvis_lhs == null ? get_displayName_0(_this__u8e3s4) : tmp0_elvis_lhs;
}
function get_description(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.Description') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p3('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  return tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x4v_1;
}
function get_displayName_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.DisplayName') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p3('text');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x4v_1;
  return tmp4_elvis_lhs == null ? _this__u8e3s4.i20() === '_id' ? 'ID' : titleCase(_this__u8e3s4.i20()) : tmp4_elvis_lhs;
}
function get_indexed(_this__u8e3s4) {
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.Index') {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function get_sentence(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.Sentence') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r3();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : first(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof StringValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  return tmp4_safe_receiver == null ? null : tmp4_safe_receiver.x4v_1;
}
function get_doesNotNeedLabel(_this__u8e3s4) {
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection())) {
      tmp = tmp0.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.DoesNotNeedLabel') {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function visibility(_this__u8e3s4, module_0) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = _this__u8e3s4.o2j();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = module_0.ndt_1.p3(element.j4s_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var tmp0_elvis_lhs = minOrNull(destination);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (_this__u8e3s4.i20() === '_id' && substringBefore(_this__u8e3s4.h2j().az().h10(), _Char___init__impl__6a9atx(47)) === 'com.lightningkite.UUID') {
      var tmp0_0 = _this__u8e3s4.o2j();
      var tmp$ret$7;
      $l$block_0: {
        // Inline function 'kotlin.collections.none' call
        var tmp_3;
        if (isInterface(tmp0_0, Collection())) {
          tmp_3 = tmp0_0.i1();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$7 = true;
          break $l$block_0;
        }
        var _iterator__ex2g4s_0 = tmp0_0.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.j4s_1 === 'com.lightningkite.lightningdb.References') {
            tmp$ret$7 = false;
            break $l$block_0;
          }
        }
        tmp$ret$7 = true;
      }
      tmp_2 = tmp$ret$7;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp0_1 = _this__u8e3s4.o2j();
      var tmp$ret$9;
      $l$block_2: {
        // Inline function 'kotlin.collections.none' call
        var tmp_4;
        if (isInterface(tmp0_1, Collection())) {
          tmp_4 = tmp0_1.i1();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
        var _iterator__ex2g4s_1 = tmp0_1.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          if (element_1.j4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
            tmp$ret$9 = false;
            break $l$block_2;
          }
        }
        tmp$ret$9 = true;
      }
      tmp_1 = tmp$ret$9;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = ensureNotNull(module_0.ndt_1.p3('com.lightningkite.lightningdb.AdminHidden'));
    } else {
      tmp_0 = FieldVisibility_EDIT_getInstance();
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_group(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.Group') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r3();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : first(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof StringValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  return tmp4_safe_receiver == null ? null : tmp4_safe_receiver.x4v_1;
}
function get_importance(_this__u8e3s4) {
  // Inline function 'kotlin.collections.find' call
  var tmp0 = _this__u8e3s4.o2j();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.j4s_1 === 'com.lightningkite.lightningdb.Importance') {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k4s_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r3();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : first(tmp2_safe_receiver);
  var tmp;
  if (tmp3_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp3_safe_receiver instanceof ByteValue() ? tmp3_safe_receiver : null;
  }
  var tmp4_safe_receiver = tmp;
  var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.v4u_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver;
  var tmp_0;
  if (tmp6_elvis_lhs == null) {
    switch (_this__u8e3s4.i20()) {
      case '_id':
        tmp_0 = _this__u8e3s4.h2j().az().h10() === 'com.lightningkite.UUID' ? 8 : 1;
        break;
      case 'title':
      case 'subject':
        tmp_0 = 1;
        break;
      case 'name':
      case 'email':
      case 'phone':
        tmp_0 = 2;
        break;
      default:
        tmp_0 = 7;
        break;
    }
  } else {
    tmp_0 = tmp6_elvis_lhs;
  }
  return tmp_0;
}
//region block: exports
export {
  get_descriptionOrDisplayName as get_descriptionOrDisplayName2lozlddigjs1n,
  get_displayName as get_displayNamehv5zo902rjy4,
  get_displayName_0 as get_displayName274cn1h5q1fsg,
  get_doesNotNeedLabel as get_doesNotNeedLabel113kjiv7j7sfi,
  get_group as get_groupb5ywq6n1gjh5,
  get_importance as get_importance1n558cdfj7ar,
  get_indexed as get_indexed3m5d5co25leom,
  get_sentence as get_sentence3mmsiuwjayd89,
  visibility as visibility122l7g68ohruw,
};
//endregion

//# sourceMappingURL=annotationReaders.mjs.map
